
import GameObject from "../modules/GameObject"
import CastingEntity from "../physics/CastingEntity"
import ManaSparkParticle from "../physics/magic/ManaSparkParticle"
import SimpleEntity from "../physics/SimpleEntity"
import Vector from "../Vector"
import PortalNode from "./nodes/action/logistics/PortalNode"
import ManaSource from "./nodes/action/unique/ManaSource"

export type ManaParticleOptions = {
	caster: CastingEntity
	source: ManaSource
	target: SimpleEntity
	costModifier?: number
	costAddition?: number
	amp?: number
	direction?: Vector,

	// external memory
	tag?: string,
	memory?: any
	portalStack?: PortalNode[]
}

export default class ManaParticle extends GameObject {
	caster
	source
	target

	amp
	direction

	costModifier
	costAddition

	// external memory usage
	tag
	memory
	portalStack

	constructor({
		caster,
		source,
		target,
		amp = 1,
		costModifier = 1,
		costAddition = 0,
		direction = new Vector(1, 0).rotateToDeg(Math.random() * 360),

		tag = '',
		memory = {},
		portalStack = [],
	}: ManaParticleOptions) {
		super()
		this.caster = caster
		this.source = source
		this.target = target

		this.costModifier = costModifier
		this.costAddition = costAddition
		this.amp = amp
		this.direction = direction

		this.tag = tag
		this.memory = memory
		this.portalStack = portalStack
	}

	setTarget(target: SimpleEntity) {
		if (this.target instanceof ManaSparkParticle) {
			this.target.kill()
		}
		this.target = target;
	}

	split(amt: number) {
		const splitParticles = []
		for (let i = 0; i < amt; i++) {
			splitParticles.push(new ManaParticle({
				caster: this.caster,
				source: this.source,
				target: this.target,
				costModifier: this.costModifier,
				costAddition: this.costAddition,
				amp: this.amp,
				direction: this.direction.clone(),

				tag: this.tag,
				memory: { ...this.memory },
				portalStack: [...this.portalStack]
			}))
		}
		return splitParticles
	}

	dispose() {
		if (this.target instanceof ManaSparkParticle) {
			this.target.kill()
		}
	}

}